<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-input-group :label="getMessage_('SWCC000329')" :inputValue="taskId_" :onChange="value => onChange({ key: 'taskId', value })" />
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button v-if="isButton_(scrId, 'CR')" line :onClick="findAllTasks"
				><i class="icon-sf-search"></i>{{ getMessage_('SWCC000244') }}</sf-button
			>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TaskManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'searchParams',
				value: {
					...this.searchParams,
					[key]: value
				}
			});
		},
		findAllTasks() {
			this.$sf_toggleLoading(true);
			this.fetchTasks_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }).finally(() => this.$sf_toggleLoading(false));
		}
	}
};
</script>

<style langType="scss"></style>
